import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Other = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M17 8.4v7.2L12 18l-5-2.4V8.4L12 6l5 2.4Zm-5-.182 3 1.44v4.683l-3 1.44-3-1.44V9.658l3-1.44Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M3 7.3a2 2 0 0 1 1.188-1.828l7-3.111a2 2 0 0 1 1.624 0l7 3.111A2 2 0 0 1 21 7.3v9.4a2 2 0 0 1-1.188 1.828l-7 3.11a2 2 0 0 1-1.624 0l-7-3.11A2 2 0 0 1 3 16.7V7.3Zm16 0v9.4l-7 3.111-7-3.11V7.3l7-3.112L19 7.3Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Other;
